import React from 'react'
import { connect } from 'react-redux'
import { Employee } from '../../store/employees/types'
import { selectEmployee } from '../../store/employees/actions'
import { fetchSuccess as servicesFetchSuccess } from '../../store/services/actions'
import { ApplicationState } from '../../store'
import { ItemContainer } from '../layout/ItemContainer'
import styled from '../../utils/styled'
import { AvailableTime } from '../../store/availableTimes/types'
import { EmployeeAvatar } from '../../styles/components/employee'
import { Link } from '../layout/Link'
import { Typography } from '../layout/Typography'
import { Box } from '../layout/Box'
import { RouteType } from '../../types/routes'
import { Footer } from '../layout/Footer'

interface PropsFromState {
  data: Employee[]
  selectedEmployee?: Employee
  selectedAvailableTime?: AvailableTime
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
  selectEmployee: typeof selectEmployee
  servicesFetchSuccess: typeof servicesFetchSuccess
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch

export const getEmployeeFullName = (firstName: string, lastName: string) => `${firstName} ${lastName}`

const Employees: React.FC<AllProps> = ({
  data,
  selectedEmployee,
  selectEmployee: dispatchSelectEmployee,
  servicesFetchSuccess: dispatchServicesFetchSuccess
}) => {
  if (!data) return null

  const isEmployeeSelected = (employeeId: number) => selectedEmployee !== undefined && selectedEmployee.id === employeeId

  const handleSelectEmployee = (employee: Employee) => {
    dispatchSelectEmployee(employee)
    dispatchServicesFetchSuccess(employee.servicesKategorien)
  }

  return (
    <>
      <Typography variant="h4" margin="0 0 1rem">
        Mitarbeiter auswählen
      </Typography>
      {data.map(employee => (
        <Link to={RouteType.Services} onClick={() => handleSelectEmployee(employee)} key={employee.id}>
          <EmployeeItemContainer isEmployeeSelected={isEmployeeSelected(employee.id)}>
            <Box flex centerVertical>
              <EmployeeAvatar src={employee.fotoUrl} alt={getEmployeeFullName(employee.vorname, employee.nachname)} />
              <Box>
                <Typography variant="body1" margin="0">
                  {getEmployeeFullName(employee.vorname, employee.nachname)}
                </Typography>
                <Typography variant="body2" margin="0.25rem">
                  {employee.title}
                </Typography>
              </Box>
            </Box>
          </EmployeeItemContainer>
        </Link>
      ))}
      <Footer />
    </>
  )
}

const EmployeeItemContainer = styled(ItemContainer)<{ isEmployeeSelected: boolean }>`
  border-color: ${({ theme, isEmployeeSelected }) => (isEmployeeSelected ? theme.colors.body : theme.colors.borders)};
`

const mapStateToProps = ({ employees, availableTimes }: ApplicationState) => ({
  data: employees.data,
  selectedEmployee: employees.selected,
  selectedAvailableTime: availableTimes.selectedTime
})

const mapDispatchToProps = {
  selectEmployee,
  servicesFetchSuccess
}

export default connect(mapStateToProps, mapDispatchToProps)(Employees)
